<template>
  <div class="mx-2">
    <span
      v-if="parceiro.plano && parceiro.plano.plano_id == 5"
      :title="parceiro.plano.plano.nome"
      ><i class="fas fa-infinity text-light"></i
    ></span>
    <b-button
      variant="light"
      v-else-if="parceiro.plano && parceiro.plano.plano_id != 5 && parceiro.plano.plano_id != 1"
      >{{ parceiro.plano.plano.nome }}</b-button
    >
    <b-button
      size="sm"
      v-else-if="parceiro.subscription"
      variant="light"
      @click="$router.push('/subscription')"
      >Assinatura
      <span
        class=""
        v-if="
          parceiro.subscription.plan &&
          parceiro.subscription.status != 'canceled'
        "
        >{{ JSON.parse(parceiro.subscription.plan).name }}</span
      >
      <span class="" v-else>cancelada</span>
    </b-button>
    <b-button
      variant="light"
      v-else-if="parceiro.plano  && parceiro.plano.plano_id == 1"
      >{{ parceiro.plano.plano.nome }}</b-button
    >
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  created() {},
  computed: {
    ...mapState("user", ["parceiro"]),
  },
};
</script>
